import styled from 'styled-components';
import React from 'react';
import { Button } from 'antd';

export const SSOSignIn = ({ src, children }) => {
  const StyledIframe = styled.iframe`
    height: 700px;
    width: 800px;
  `;
  return <StyledIframe src={src}>{children}</StyledIframe>;
};

export const PaddedButton = styled(Button)`
  margin: 10px;
`;

export const LogoBtn = ({ src, onClick, alt }) => {
  const StyledButton = styled(Button)`
    width: 130px;
    height: 100px;
    margin: 10px;
    padding: 0;
    display: inline-block;
  `;
  const StyledImg = styled.img`
    width: 120px;
    display: block;
    padding: 10px;
  `;
  return (
    <StyledButton onClick={onClick}>
      <StyledImg src={src} alt={alt} />
    </StyledButton>
  );
};

export const OffPlatformBtn = styled(Button)`
  width: 130px;
  height: 100px;
  margin: 10px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #e5e5e5;
  color: #222;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  line-height: 1.2;
  white-space: normal;
`;

export const CenteredDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
`;

export const NewsEntBtn = styled(Button)`
  width: 130px;
  height: 100px;
  margin: 10px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  white-space: pre-line;
`;

export const RokuBtn = styled(NewsEntBtn)`
  background-color: #6f1ab1; // Roku purple
  color: #ffffff; // White text for better contrast
`;

export const HuluPlusBtn = styled(NewsEntBtn)`
  background-color: #1ce783; // Hulu green
  color: #040405; // Dark text for better contrast
`;

export const FuboBtn = styled(NewsEntBtn)`
  background-color: #ea2127; // FuboTV's brand red
  color: #ffffff; // White text for better contrast
`;
